import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';
// import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { GlobalFunction } from 'src/app/shared/global-function';
import { AuthResponseData } from 'src/app/shared/models/authentication/auth-response-data';
import { Router } from '@angular/router';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { IEmployee } from 'src/app/shared/models/employee/employee.model';
import { AuthService } from 'src/app/auth/auth.service';
import { LicenseService } from 'src/app/shared/services/license.service';
import { ILicense } from 'src/app/shared/models/license/license.model';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';
@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MenuService]
})
export class SidenavComponent implements OnInit, OnDestroy
{
    // @ViewChild('sidenavPS', { static: true }) sidenavPS: PerfectScrollbarComponent;

    // TODO: component überarbeiten und alles nicht gebrauchte rausschmeißen

    // OK
    //public userImage= './assets/img/users/user.png';
    public userImage = './assets/img/profil_dummy.jpg';

    private subscriptions: Subscription[] = [];

    roles: string;
    public employee: IEmployee;
    public userName = "";
    authResponseData: AuthResponseData;

    public menuOrder: number = 0;
    public menuItems: Array<any>;
    public settings: Settings;
    public loading = true;
    constructor(
        public appSettings: AppSettings,
        public menuService: MenuService,
        private authService: AuthService,
        private employeeService: EmployeeService,
        public translate: TranslateService,
        private router: Router,
        private licenseService: LicenseService
    )
    {
        this.settings = this.appSettings.settings;
    }

    ngOnInit()
    {

        // for start loading of the items
        this.subscriptions.push(this.licenseService.getLicense().subscribe(license =>
        {
            this.SetMenuItems(license);
        }));

        // react on changes
        // but do not reload the menu items
        this.subscriptions.push(this.licenseService.licenseChangeSubject.subscribe(license =>
        {
            this.SetMenuItems(license);
        }));

    }

    public onOrderSelected(matSelect: MatSelectChange): void
    {
        this.menuOrder = matSelect.value;
        this.subscriptions.push(this.licenseService.getLicense().subscribe(license =>
            {
                this.SetMenuItems(license);
            }));
    }

    private SetMenuItems(license: ILicense)
    {

        this.menuItems = this.menuService.getLicenseMenu(license, this.menuOrder);

        this.loading = false;

        // set the heading left
        if (!GlobalFunction.isEmpty(localStorage.getItem('AppointmentManagementUser')))
        {
            this.authResponseData = JSON.parse(localStorage.getItem('AppointmentManagementUser'));
            this.userName = this.authResponseData.userName;
            // can be more then one
            this.roles = this.authResponseData.userRoles.toString();
            this.subscriptions.push(this.employeeService.get(this.authResponseData.userId).subscribe(data =>
            {
                this.employee = data;
            }));
        }
    }

    public closeSubMenus()
    {
        let menu = document.querySelector(".sidenav-menu-outer");
        if (menu)
        {
            for (let i = 0; i < menu.children[0].children.length; i++)
            {
                let child = menu.children[0].children[i];
                if (child)
                {
                    if (child.children[0].classList.contains('expanded'))
                    {
                        child.children[0].classList.remove('expanded');
                        child.children[1].classList.remove('show');
                    }
                }
            }
        }
    }

    // public updatePS(e)
    // {
    //      this.sidenavPS.directiveRef.update();
    // }

    logout()
    {
        this.authService.logout();
        this.router.navigate(['/Login']);
    }

    ngOnDestroy()
    {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

}
